[
  {
    "id": "todo",
    "title": "TODO.TXT",
    "paper": "white",
    "body": "- finish the beige box\n- tape the Wrack poster straighter (no)\n- do not unplug the knot\n- Flappy Bee: shipped in Games\n- buy more Liqueef (joke)"
  },
  {
    "id": "ideas",
    "title": "ideas",
    "paper": "yellow",
    "body": "call fake 7pm\n\nmore games on the pad later\nmaybe a minesweeper if I get bored\n\nthe CRT is the site. that's the bit."
  },
  {
    "id": "bees",
    "title": "bees!!!!",
    "paper": "pink",
    "body": "Flappy Bee is in Games.\nDouble-click Games, hit Play.\n\nDon't kiss the cactus."
  }
]
